// removed by extract-text-webpack-plugin
module.exports = {"star":"index__star___5Kpgz"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Stars/index.styl
 ** module id = 205
 ** module chunks = 0
 **/